import { Box, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import SharedMessagePair from "./SharedMessagePair";

export default function SharedChatThread({ messagePairs, dir }) {
  const intl = useIntl();

  return (
    <Box className="shared-chat-thread">
      {messagePairs.length === 0 ? (
        <Typography className="shared-chat-empty">
          {intl.formatMessage({
            id: "chatbot.sharedEmpty",
            defaultMessage:
              dir === "rtl"
                ? "لا توجد رسائل في هذه المحادثة."
                : "No messages in this conversation.",
          })}
        </Typography>
      ) : (
        messagePairs.map((pair, index) => (
          <SharedMessagePair
            key={`${pair?.createdAt || "msg"}-${index}`}
            pair={pair}
            index={index}
            dir={dir}
          />
        ))
      )}
    </Box>
  );
}
